import React, { useState, useEffect } from 'react';
import {
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
  List,
  ListItem,
  Button,
  Box,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import RoadmapHeader from './components/RoadmapHeader';
const BASE_URL = process.env.REACT_APP_FRONTEND_URL;


const levels = [
  {
    label: 'AI Start 1: Beginner Foundations',
    steps: [
      {
        label: 'Step 1: Why Learn Local AI Tools? (What They Are & Why They Matter)',
  description: [
    { 
      text: 'Why use local AI tools instead of paid platforms like Midjourney or DALL·E?',
      link: `${BASE_URL}/blog/stable-diffusion-guide`,
    },

    { text: 'Benefits of local tools: Full control, free to use, privacy, flexibility.' },
    { text: 'Overview of popular local AI tools:' },
    {text: '- Stable Diffusion (core image generation engine)' },
    { text: '- A1111 Web UI (older, popular web-based frontend)' },
    { text: '- ComfyUI (modern node-based workflow system)' },
    { text: '- Fooocus, InvokeAI, and others (optional alternatives)' },
    { text: 'Why we focus on **ComfyUI**: it’s modular, fast, and becoming the new standard.' },
  ],
      },
  {
    label: 'Step 2: Your First AI Image with ComfyUI',
  description: [
    {
      text: 'Explore the ComfyUI interface: node workspace, preview panel, and toolbar.',
    },
    {
      text: 'Load a basic Text-to-Image workflow: prompt → image → save.',
    },
    {
      text: 'Understand key settings: sampler, steps, CFG scale, and resolution.',
    },
    {
      text: 'Write your first prompt: using positive and negative prompt nodes.',
    },
    {
      text: 'Generate, preview, and save your first AI image.',
    },
  ],
  },
      {
        label: 'Understanding Checkpoint Models',
        description: [
          { text: 'What Checkpoint Models Are' },
          { text: 'Using Models Effectively' },
          { text: 'Switching Between Models' },
        ],
      },
      {
        label: 'Prompt Engineering',
        description: [
          { text: 'How to Structure Prompts.' },
          { text: 'Using Adjectives and Context' },
          { text: 'Prompt Weighting' },
          { text: 'Using Multiple Prompts' },
          { text: 'Controlling Style and Composition' },
        ],
      },
      {
        label: 'Troubleshooting Common Issues',
        description: [
          { text: 'Bad Outputs' },
          { text: 'Unresponsive Interface' },
          { text: 'VRAM or Memory Issues' },
          { text: 'Slow Image Generation' },
        ],
      },
    ],
  },
  {
  label: 'AI Boost 2: Going Beyond the Basics',
  steps: [
    {
      label: 'Creative Image Manipulation',
      description: [
        { text: 'Image-to-Image Workflow & Use Cases' },
        { text: 'Generate Variations & Multiple Outputs' },
        { text: 'Resize, Inpaint, and Outpaint Images' }
      ]
    },
    {
      label: 'Boosting Quality with Upscalers and VAE',
      description: [
        { text: 'What is AI Upscaling and How to Use It' },
        { text: 'Custom Upscale Factor & High Res Fix' },
        { text: 'Understanding VAE for Cleaner Results' }
      ]
    },
    {
      label: 'Guided Generation with ControlNet & Style Tools',
      description: [
        { text: 'Use ControlNet to Copy Pose, Depth, Edges' },
        { text: 'Multiple ControlNets in One Workflow' },
        { text: 'Style Presets: SDXL, 1.5, and Flux' }
      ]
    },
    {
      label: 'Using LoRA and Textual Inversion',
      description: [
        { text: 'What is LoRA and How to Use Multiple LoRAs' },
        { text: 'Change Style or Identity Using LoRA' },
        { text: 'Textual Inversion & Embeddings in Prompts' }
      ]
    },
    {
      label: 'Advanced Prompting, Conditioning & AnimateDiff',
      description: [
        { text: 'Combine Prompts Using Conditioning Nodes' },
        { text: 'Prompt Break, Average, and Merge Methods' },
        { text: 'Introduction to AnimateDiff & Prompt Travel' }
      ]
    }
  ]
},

  {
  label: 'AI SkillUp 3: Text-to-Video Mastery',
  steps: [
    {
      label: 'Foundations: AnimateDiff and Prompt Travel',
      description: [
        { text: 'What is AnimateDiff and How It Works' },
        { text: 'Installing AnimateDiff in ComfyUI' },
        { text: 'Using Prompt Travel and Looping Techniques' },
        { text: 'Video-to-Video with AnimateDiff' },
        { text: 'AnimateDiff with Motion LoRAs and Style Guidance' }
      ],
    },
    {
      label: 'Local Text-to-Video Models: WAN, LTXV, CogVideoX',
      description: [
        { text: 'Overview: WAN v2.1, LTXV, CogVideoX - When to Use Each' },
        { text: 'Installing WAN Video and Setup in ComfyUI' },
        { text: 'Using LTXV for Stylized Text-to-Video' },
        { text: 'CogVideoX - High Detail Text-to-Video with Face Fidelity' },
        { text: 'Prompting, Parameters, and Output Optimization' },
      ],
    },
    {
      label: 'Deforum: Procedural Video from A1111',
      description: [
        { text: 'What is Deforum and How It Works' },
        { text: 'Using Deforum’s Keyframes and Camera Animation' },
        { text: 'Prompt Interpolation and Effects in Deforum' },
        { text: 'Best Settings for Long and Smooth Renders' }
      ],
    },
    {
      label: 'Enhancing and Refining AI Videos',
      description: [
        { text: 'Fix Faces and Hands Frame-by-Frame with Adetailer or Inpainting' },
        { text: 'Enhance with Upscaling, VAE, and Style LoRAs' },
        { text: 'Convert Image Sequences into Videos (FFmpeg, Flowframes)' },
        { text: 'Use Frame Interpolation to Boost Frame Rate (RIFE, DAIN)' }
      ],
    },
    {
      label: 'Creative AI Video Effects and Tricks',
      description: [
        { text: 'Animate Still Images with Looping or Ken Burns Style' },
        { text: 'Make Infinite Zoom and Dream-like Loops' },
        { text: 'Combine Multiple Video Models (AnimateDiff + WAN)' },
        { text: 'Add Music and Export as MP4/GIF for Sharing' }
      ],
    },
  ]
}
,
  {
    label: 'AI Power 4: Advanced Creations',
    steps: [
      {
        label: 'Enhancing Images with Regional Prompting',
        description: [
          { text: 'What is Regional Prompting' },
          { text: 'Overview of General Settings' },
          { text: 'Diving Into Matrix Mode' },
          { text: 'Using Masks for Precise Control' },
          { text: 'Prompt Section for Fine-Tuning' },
        ],
      },
      {
        label: 'Training a LoRA Model, Textual Inversion, and Hypernetworks',
        description: [
          { text: 'Training LoRA Model' },
          { text: 'Training Textual Inversion' },
          { text: 'Training Hypernetworks' },
        ],
      },
      {
        label: 'DreamBooth Training: Customizing AI Models & LoRAs',
        description: [
          { text: 'Model Training' },
          { text: 'LoRA Training' },
          { text: 'Character Training' },
          { text: 'Style Training' },
          { text: 'Object Training' },
        ],
      },
      {
        label: 'Generating Consistent Faces',
        description: [
          { text: 'Challenges in Generating Consistent Faces' },
          { text: 'Techniques for Consistency' },
          { text: 'Practical Example' },
        ],
      },
      {
        label: 'Python API Automation and Batch Processing',
        description: [
          { text: 'Generating multiple images at once' },
          { text: 'Automating workflows with Python Scripts' },
        ],
      },
    ],
  },
];



const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1400,
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(2),
    marginTop: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '20px',
      textAlign: 'center',
    },
  },
  stepperContainer: {
    overflowX: 'auto', // Add horizontal scrolling for small screens
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  section: {
    marginTop: theme.spacing(3),
  },
}));

const Roadmap = () => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'Stable Diffusion - Step-by-Step Roadmap';
  }, []);
  const matchesSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const [activeStep, setActiveStep] = useState(0);
  const [activeLevelStep, setActiveLevelStep] = useState(0);

  const handleLevelChange = (index) => {
    setActiveStep(index);
    setActiveLevelStep(0);
  };

  const handleStepClick = (index) => {
    setActiveLevelStep(index);
  };

  const roadmapHeaderProps = {
    header: 'AI Creativity Roadmap – From Beginner to Pro',
    subheading: 'Level up with ComfyUI, SD, and modern open-source tools',
    progress: 50, // Example progress value (you can make this dynamic based on the user's progress)
  };

  return (
    <Box>
      <RoadmapHeader
        header={roadmapHeaderProps.header}
        subheading={roadmapHeaderProps.subheading}
        progress={roadmapHeaderProps.progress}
      />

      <div className={classes.container}>
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontSize: matchesMD ? (matchesSM ? '1.3rem' : '1.35rem') : '1.45rem',
            letterSpacing: matchesMD ? '0.4px' : '0.9px',
            lineHeight: matchesMD ? '33px' : '40px',
          }}
          gutterBottom
        >
          Your AI Roadmap – From Beginner to Advanced
        </Typography>

        <Box className={classes.stepperContainer} sx={{ marginTop: matchesMD ? '1.5rem' : '2rem' }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {levels.map((level, index) => (
              <Step key={level.label}>
                <StepLabel onClick={() => handleLevelChange(index)} style={{ cursor: 'pointer' }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: matchesMD ? (matchesSM ? 520 : 520) : 501,
                      fontSize: matchesMD ? (matchesSM ? '0.9rem' : '1.2rem') : '1.25rem',
                      letterSpacing: matchesMD ? '0.2px' : '0.5px',
                      lineHeight: matchesMD ? '25px' : '35px',
                      color: index <= activeStep ? 'inherit' : 'rgba(0, 0, 0, 0.6)',
                    }}
                  >
                    {level.label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Paper elevation={3} style={{ padding: '16px', marginTop: '24px' }}>
          <Typography
            variant="h2"
            sx={{
              color: '#004D49',
              fontSize: matchesMD ? '1.2rem' : '1.35rem',
              letterSpacing: matchesMD ? '0.4px' : '0.9px',
              lineHeight: matchesMD ? '33px' : '40px',
            }}
            gutterBottom
          >
            {levels[activeStep].label}
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: matchesMD ? '1.2rem' : '1.30rem',
              letterSpacing: matchesMD ? '0.4px' : '0.9px',
              lineHeight: matchesMD ? '33px' : '40px',
            }}
            gutterBottom
          >
            Detailed Steps:
          </Typography>
          <Stepper activeStep={activeLevelStep} orientation="vertical">
            {levels[activeStep].steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel onClick={() => handleStepClick(index)} style={{ cursor: 'pointer' }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: matchesMD ? (matchesSM ? '1.1rem' : '1.25rem') : '1.29rem',
                      letterSpacing: matchesMD ? '0.2px' : '0.5px',
                      lineHeight: matchesMD ? '25px' : '35px',
                    }}
                  >
                    {step.label}
                  </Typography>
                </StepLabel>
                <StepContent>
                  <List>
                    {step.description.map((point, idx) => (
                      <ListItem key={idx}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: matchesMD ? (matchesSM ? '1.1rem' : '1.25rem') : '1.29rem',
                            letterSpacing: matchesMD ? '0.2px' : '0.5px',
                            lineHeight: matchesMD ? '25px' : '35px',
                          }}
                          component={point.link ? 'a' : 'p'}
                          href={point.link || undefined}
                          target={point.link ? '_blank' : undefined}
                          style={{ textDecoration: point.link ? 'underline' : 'none', color: point.link ? '#0073e6' : 'inherit' }}
                        >
                          {point.text}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Paper>
      </div>
    </Box>
  );
};

export default Roadmap;
